namespace RioERP.Products {
    export interface ProductBillingItemSpecificationsRow {
        Id?: number;
        ProductId?: number;
        ProductBillingItemId?: number;
        ProductSpecificationId?: number;
        PriceAdjustment?: number;
        EAdjustmentType?: Web.Enums.EAdjustmentType;
        IsApplicable?: boolean;
        IsActive?: boolean;
        ProductBillingItemProductId?: number;
        ProductBillingItemBillingItemName?: string;
        ProductBillingItemGrossAmount?: number;
        ProductBillingItemEDiscountType?: number;
        ProductBillingItemTaxCategoryId?: number;
        ProductBillingItemHsnMasterId?: number;
        ProductBillingItemIncludingTax?: boolean;
        ProductBillingItemInvoiceCompanyId?: number;
        ProductBillingItemSpecialGrossAmount?: number;
        ProductBillingItemStartDate?: string;
        ProductBillingItemEndDate?: string;
        ProductBillingItemIsActive?: boolean;
        ProductBillingItemInsertUserId?: number;
        ProductBillingItemInsertDate?: string;
        ProductBillingItemUpdateUserId?: number;
        ProductBillingItemUpdateDate?: string;
        ProductSpecificationSpecificationName?: string;
        ProductSpecificationProductId?: number;
        ProductSpecificationSpecificationCode?: number;
        ProductSpecificationHasBooks?: boolean;
        ProductSpecificationHasPendrive?: boolean;
        ProductSpecificationIsLive?: boolean;
        ProductSpecificationProcessOrderOnPaid?: boolean;
        ProductSpecificationEopens?: number;
        ProductSpecificationEWatchtime?: number;
        ProductSpecificationEValidityType?: number;
        ProductSpecificationEValidity?: number;
        ProductSpecificationValidTill?: string;
        ProductSpecificationAllowedDevices?: string;
        ProductSpecificationHasCourier?: boolean;
        ProductSpecificationInsertUserId?: number;
        ProductSpecificationInsertDate?: string;
        ProductSpecificationUpdateUserId?: number;
        ProductSpecificationUpdateDate?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace ProductBillingItemSpecificationsRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Products.ProductBillingItemSpecifications';
        export const deletePermission = 'Products:ProductsManagement:Modify';
        export const insertPermission = 'Products:ProductsManagement:Modify';
        export const readPermission = 'Products:ProductsManagement:View';
        export const updatePermission = 'Products:ProductsManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            ProductId = "ProductId",
            ProductBillingItemId = "ProductBillingItemId",
            ProductSpecificationId = "ProductSpecificationId",
            PriceAdjustment = "PriceAdjustment",
            EAdjustmentType = "EAdjustmentType",
            IsApplicable = "IsApplicable",
            IsActive = "IsActive",
            ProductBillingItemProductId = "ProductBillingItemProductId",
            ProductBillingItemBillingItemName = "ProductBillingItemBillingItemName",
            ProductBillingItemGrossAmount = "ProductBillingItemGrossAmount",
            ProductBillingItemEDiscountType = "ProductBillingItemEDiscountType",
            ProductBillingItemTaxCategoryId = "ProductBillingItemTaxCategoryId",
            ProductBillingItemHsnMasterId = "ProductBillingItemHsnMasterId",
            ProductBillingItemIncludingTax = "ProductBillingItemIncludingTax",
            ProductBillingItemInvoiceCompanyId = "ProductBillingItemInvoiceCompanyId",
            ProductBillingItemSpecialGrossAmount = "ProductBillingItemSpecialGrossAmount",
            ProductBillingItemStartDate = "ProductBillingItemStartDate",
            ProductBillingItemEndDate = "ProductBillingItemEndDate",
            ProductBillingItemIsActive = "ProductBillingItemIsActive",
            ProductBillingItemInsertUserId = "ProductBillingItemInsertUserId",
            ProductBillingItemInsertDate = "ProductBillingItemInsertDate",
            ProductBillingItemUpdateUserId = "ProductBillingItemUpdateUserId",
            ProductBillingItemUpdateDate = "ProductBillingItemUpdateDate",
            ProductSpecificationSpecificationName = "ProductSpecificationSpecificationName",
            ProductSpecificationProductId = "ProductSpecificationProductId",
            ProductSpecificationSpecificationCode = "ProductSpecificationSpecificationCode",
            ProductSpecificationHasBooks = "ProductSpecificationHasBooks",
            ProductSpecificationHasPendrive = "ProductSpecificationHasPendrive",
            ProductSpecificationIsLive = "ProductSpecificationIsLive",
            ProductSpecificationProcessOrderOnPaid = "ProductSpecificationProcessOrderOnPaid",
            ProductSpecificationEopens = "ProductSpecificationEopens",
            ProductSpecificationEWatchtime = "ProductSpecificationEWatchtime",
            ProductSpecificationEValidityType = "ProductSpecificationEValidityType",
            ProductSpecificationEValidity = "ProductSpecificationEValidity",
            ProductSpecificationValidTill = "ProductSpecificationValidTill",
            ProductSpecificationAllowedDevices = "ProductSpecificationAllowedDevices",
            ProductSpecificationHasCourier = "ProductSpecificationHasCourier",
            ProductSpecificationInsertUserId = "ProductSpecificationInsertUserId",
            ProductSpecificationInsertDate = "ProductSpecificationInsertDate",
            ProductSpecificationUpdateUserId = "ProductSpecificationUpdateUserId",
            ProductSpecificationUpdateDate = "ProductSpecificationUpdateDate",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
